import React from 'react';
import {useEffect, useState} from "react";
import {Progress, useProps} from '@mantine/core';
import {MantineSize} from "@mantine/core/lib/core";
import {COR} from "../../config/constantes/constantes-mantine";
import {ProgressRootProps} from "@mantine/core/lib/components/Progress/ProgressRoot/ProgressRoot";
import classes from './barra-progresso.module.css'

interface BarraProgressoProps extends ProgressRootProps {
  percentual: number;
  animado?: boolean;
  texto?: string;
  tamanho?: MantineSize | number;
}

const defaultProps: Partial<BarraProgressoProps> = {
  percentual: 0,
  animado: true,
  tamanho: 20,
};
export function getCorPorPorcentagem(percentual: number) {
  if (percentual < 15) return (COR.PERIGO)
  if (percentual >= 15 && percentual < 30) return(COR.ALERTA)
  if (percentual >= 30 && percentual < 45) return(COR.SECUNDARIO)
  if (percentual >= 45 && percentual < 60) return(COR.INFO)
  if (percentual >= 60 && percentual < 90) return(COR.PRIMARIO)
  return(COR.SUCESSO)
}
export default function BarraProgresso(props: BarraProgressoProps) {
  const {percentual, animado, tamanho} = useProps('BarraProgresso', defaultProps, props);

  const [cor, setCor] = useState('')

  useEffect(() => {
      setCor(getCorPorPorcentagem(percentual))
    }
  )

  return (
    <Progress.Root size={tamanho} classNames={{
      root: classes.root,
      label: classes.label,
    }} {...props}>
      <Progress.Section value={percentual} color={cor} animated={animado}>
        <Progress.Label>{props.texto} {props.percentual}%</Progress.Label>
      </Progress.Section>
    </Progress.Root>
  );
}